import React from 'react';
import { Card, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * ClimatePledgeCard
 * Displays Itaca's 1% climate pledge using Stripe Climate badge.
 */
const ClimatePledgeCard = () => {
  const { t } = useTranslation();

  return (
    <Card
      style={{
        maxWidth: 860,
        marginTop: 0,
        margin: '24px auto 0',
        borderRadius: 12,
        background: 'linear-gradient(135deg, #f0fff4 0%, #e6fffb 100%)',
        border: '1px solid #e6fffb',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
      }}
      styles={{ body: { padding: 24 } }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div aria-hidden="true" style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          borderRadius: 8,
          background: 'linear-gradient(135deg, #b7eb8f, #73d13d)'
        }}>
          <span style={{ fontSize: 20, lineHeight: '20px' }}>🌿</span>
        </div>
        <div style={{ flex: 1 }}>
          <Typography.Text style={{ display: 'block', color: '#1a1a1a', marginBottom: 0, fontSize: 18, lineHeight: 1.6, fontWeight: 500 }}>
            {t('pricing.climate_message')}
          </Typography.Text>
          <div style={{ marginTop: 8 }}>
            <a
              href="https://climate.stripe.com/WYeQOe"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'var(--main-color)',
                fontWeight: 500,
                textDecoration: 'underline',
              }}
            >
              {t('pricing.climate_cta')} →
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ClimatePledgeCard;
